__turbopack_context__.v({
  "red": "BrowsingLevelBadge-module__COXIDG__red",
  "root": "BrowsingLevelBadge-module__COXIDG__root",
});
